import { connect } from 'react-redux'
import { withApollo } from 'react-apollo';
import CheckoutBag from './CheckoutBag.jsx';
import actions from './../../../actions/';

const mapStateToProps = ({
  cart,
  auth: {
    authToken,
    currency,
  }
}, ownProps) => ({
  cart,
  currency,
  isLoggedIn: authToken? true: false,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setLineQuantity: (updatedLine) => dispatch(actions.setLineQuantity(updatedLine)),
  updateCartQuantity: (totalQuantity) => dispatch(actions.updateCartQuantity(totalQuantity)),
  removeLineItem: (lineId) => dispatch(actions.removeLineItem(lineId)),
  updateCartTotalPrice: (totalPrice) => dispatch(actions.updateCartTotalPrice(totalPrice)),
  updateCartSubTotalPrice: (subTotalPrice) => dispatch(actions.updateCartSubTotalPrice(subTotalPrice)),
  updateCartLineTotalPrice: (lineId, totalPrice) => dispatch(actions.updateCartLineTotalPrice(lineId, totalPrice)),
  guestEditVariantQuantity: (variantId, quantity) => dispatch(actions.guestEditVariantQuantity(variantId, quantity)),
  guestRemoveVariantQuantity: (lineId) => dispatch(actions.guestRemoveVariantQuantity(lineId)),
  setDiscount: (discountInfo) => dispatch(actions.setDiscount(discountInfo)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(CheckoutBag));